module.exports = __webpack_public_path__ + "img/lang-en.9f0cdd56.png";